namespace GeniuzPOS.Inventory {
    export class IcStockApproveHdColumns {
        static columnsKey = 'Inventory.IcStockApproveHd';
    }
}
